















import mixins from 'vue-typed-mixins';
import ResourceUtils, { Bookshelf } from '@/utils/ResourceUtils';
export default mixins().extend({
  computed: {
    headers(): any {
      return [{ text: this.$tc('model.bookshelf.name'), value: 'name' }];
    },
  },

  data(): {
    items?: Bookshelf[];
  } {
    return {
      items: undefined,
    };
  },

  async mounted() {
    try {
      this.items = await ResourceUtils.api.bookshelf.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async create() {
      await this.$router.push({
        name: 'bookshelf-create',
      });
    },

    async edit(item: Bookshelf) {
      await this.$router.push({
        name: 'bookshelf-edit',
        params: { id: `${item.id}` },
      });
    },

    async remove(item: Bookshelf) {
      try {
        await this.$confirm(
          this.$i18n
            .t('validation.confirmation.delete', [this.$translate(item.name)])
            .toString(),
          async () => {
            if (item.id && this.items) {
              await ResourceUtils.api.bookshelf.remove(item.id);

              this.$toast.push({
                type: 'success',
                text: this.$languageobj('validation.success.delete', {
                  values: [item.name],
                }),
              });

              const index = this.items.findIndex((val) => val.id === item.id);
              if (index >= 0) {
                this.items.splice(index, 1);
              }
            }
          }
        );
      } catch (error) {
        this.$alert.show('remove', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
